// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { patchCustomer, postAddCustomer } from 'services/CustomerService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useCustomerMutation = <CustomerType extends object>() => {
  return useMutation({
    mutationFn: postAddCustomer<CustomerType>,
    onError: (error: BaseErrorResponse, data) => {
      if (error?.status !== 400) {
        logSentryError('Error: useCustomerMutation', error, data)
      }
    },
  })
}

export const useCustomerPatchMutation = <CustomerPatchData extends object>() => {
  return useMutation({ mutationFn: patchCustomer<CustomerPatchData> })
}
